import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { routes } from 'utils/routes';
import { DashboardPage } from 'containers/DashboardPage';
import { AppRoutingShared } from 'containers/AppRouting/AppRoutingShared';
import { AdminPageLayout } from 'design/adminPageLayout';
import { AdminNavigation } from 'containers/AdminNavigation';
import { SignOutPage } from 'containers/SignOutPage';
import { ProductsPageContent } from 'containers/ProductsPageContent';
import { ClientsPage } from 'containers/ClientsPage';
import { CardPaymentsPage } from 'containers/CardPaymentsPage';
import { PartnersPage } from 'containers/PartnersPage';
import { GiroPaymentsPage } from 'containers/GiroPaymentsPage/GiroPaymentsPage';
import { BillsPage } from 'containers/BillsPage/BillsPage';
import { PromocodesPage } from 'containers/PromocodesPage/PromocodesPage';

export const AppRoutingAdmin = () => {
  return (
    <Switch>
      <Route path={routes.clientsPattern()}>
        <ClientsPage />
      </Route>
      <Route path={routes.clientsRootPattern()}>
        <Redirect to={routes.clients()} />
      </Route>

      <Route path={routes.archivePattern()}>
        <ClientsPage />
      </Route>
      <Route path={routes.archiveRootPattern()}>
        <Redirect to={routes.archive()} />
      </Route>

      <Route path={routes.billsPattern()}>
        <BillsPage />
      </Route>
      <Route path={routes.billsRootPattern()}>
        <Redirect to={routes.bills()} />
      </Route>

      <Route path={routes.cardPaymentsPattern()}>
        <CardPaymentsPage />
      </Route>
      <Route path={routes.cardPaymentsRootPattern()}>
        <Redirect to={routes.cardPayments()} />
      </Route>

      <Route path={routes.giroPaymentsPattern()}>
        <GiroPaymentsPage />
      </Route>
      <Route path={routes.giroPaymentsRootPattern()}>
        <Redirect to={routes.giroPayments()} />
      </Route>

      <Route path={routes.productsPattern()}>
        <AdminPageLayout
          sidebarNode={<AdminNavigation />}
          contentNode={<ProductsPageContent />}
        />
      </Route>

      <Route path={routes.promocodesPattern()}>
        <PromocodesPage />
      </Route>

      <Route path={routes.partnersPattern()}>
        <PartnersPage />
      </Route>
      <Route path={routes.partnersRootPattern()}>
        <Redirect to={routes.partners()} />
      </Route>

      <Route path={routes.signOutPattern()}>
        <SignOutPage />
      </Route>

      <Route path={routes.dashboardPattern()}>
        <AdminPageLayout
          sidebarNode={<AdminNavigation />}
          contentNode={<DashboardPage />}
        />
      </Route>

      <Route path="/" exact>
        <Redirect to={routes.dashboard()} />
      </Route>

      <Route path="/">
        <AppRoutingShared />
      </Route>
    </Switch>
  );
};
